import type { FC, ReactNode } from "react";
import { Suspense } from "react";

type Props = {
  element: ReactNode;
}

const LazyPage: FC<Props> = ({ element: component }) => (
  <Suspense fallback="">
    <div className="flex h-full w-full flex-1 animate-fadeIn flex-col">{component}</div>
  </Suspense>
);

export default LazyPage;
